import React, { Component } from 'react'
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

class ReceptoresItemActions extends Component {

  render() {

    return (
      <>
        { Guardian.allows('receptor.bloquear') && (
          <Dropdown as={ ButtonGroup } alignRight={ true }>
            <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic">
              Acciones { ' ' }
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as="div">Bloquear</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </>
    )
  }
}

export default ReceptoresItemActions;